var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex flex-column" },
      [
        _c(
          "b-button",
          {
            staticClass: "mb-5",
            attrs: {
              variant: _vm.forms.flowDetail ? "warning" : "outline-warning"
            },
            on: {
              click: function($event) {
                return _vm.setForm("flowDetail", true)
              }
            }
          },
          [_vm._v(" Detalle de flujo ")]
        ),
        _c(
          "b-button",
          {
            staticClass: "mb-5",
            attrs: { variant: _vm.forms.observers ? "info" : "outline-info" },
            on: {
              click: function($event) {
                return _vm.setForm("observers", true)
              }
            }
          },
          [_vm._v(" Observadores ")]
        ),
        _c(
          "b-button",
          {
            staticClass: "mb-5",
            attrs: {
              variant: _vm.forms.consequences ? "info" : "outline-info"
            },
            on: {
              click: function($event) {
                return _vm.setForm("consequences", true)
              }
            }
          },
          [_vm._v(" Consecuencias ")]
        ),
        _c(
          "b-button",
          {
            staticClass: "mb-5",
            attrs: { variant: _vm.forms.steps ? "warning" : "outline-warning" },
            on: {
              click: function($event) {
                return _vm.setForm("steps", true)
              }
            }
          },
          [_vm._v(" Pasos ")]
        ),
        _c(
          "b-button",
          {
            staticClass: "save-button margin",
            attrs: {
              disabled: _vm.loadingBtn,
              variant: "success",
              "data-cy": "approvals-action-save"
            },
            on: { click: _vm.saveData }
          },
          [_vm._v(" " + _vm._s(_vm.getBtnText) + " ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }